import { createContext } from "react";

const PropertyFormTransactionsContext = createContext();

export default PropertyFormTransactionsContext;